import { validate } from './validations';
import {build} from '../../services/crudFactory';
import {Action} from '../../services/actions.factory';
const BASE_PATH = '/lottustech/testes/contatos';
const crud = build(validate,BASE_PATH);
const prefix = 'CRUDContato'
const actions = new Action(prefix,crud);
const types = actions.types;
export {types, actions};
